import { Input, Button } from "../../../../../../components"
import { Controller, useFormContext } from "react-hook-form"
import type { ProfileList } from "../../types"
import { useState, useEffect } from "react";
import { MapPreview } from "../../../../../../components/widgets/MapPreview";
import { handleMapInput } from "../../../Utils/mapUtils";

interface MapProps {
  action?: "CREATE" | "UPDATE" | "DETAIL"
  onSubmit: (newState: any) => void
  isActiveSubmit?: boolean
  permission?: string
}

export const FormMap:React.FC<MapProps> = ({ action, onSubmit, isActiveSubmit, permission }) => {
  const { control, getValues, handleSubmit, formState, setError, clearErrors } = useFormContext<ProfileList>()
  const [loading, setLoading] = useState(false);
  const [embedLink, setEmbedLink] = useState("");

  useEffect(() => {
    const linkMap = getValues("link_map");
    if (linkMap && action !== "CREATE") {
      const { cleaned, valid } = handleMapInput(linkMap);
      if (valid) {
        setEmbedLink(cleaned);
      }
    }
  }, [action, getValues]);

  const handleMapChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: any,
    fieldState: any
  ) => {
    const input = e.target.value;
    const { cleaned, valid } = handleMapInput(input);

    field.onChange(cleaned);

    if (!valid && cleaned !== "") {
      setEmbedLink("");
      setError("link_map", {
        type: "manual",
        message:
          "Please enter a valid Google Maps Embed URL. Example: https://www.google.com/maps/embed?pb=...",
      });
      return;
    }

    clearErrors("link_map");
    setEmbedLink(cleaned);
    setLoading(true);
  };

  const handleMapLoad = () => {
    setLoading(false);
  };

  return (
    <div>
      <section>
        <div className="flex">
          <div className="w-full">
            <Controller
              control={control}
              name="link_map"
              render={({ field, fieldState }) => 
                <Input 
                  {...field} 
                  onChange={(e) => handleMapChange(e, field, fieldState)}
                  label="LINK MAP" 
                  className="w-full" 
                  error={fieldState.error?.message}
                  placeholder="Input link map" 
                  value={field.value ?? ""} 
                  disabled={action === "DETAIL"} 
                />
              }
            />

            {embedLink && (
              <MapPreview
                embedLink={embedLink}
                loading={loading}
                onLoad={handleMapLoad}
              />
            )}
          </div>
        </div>
      </section>
      {action !== "DETAIL" &&
        <div className="flex justify-end">
          <Button 
            type="button"
            className="!none mt-5" 
            color="primary"
            loading={formState.isSubmitting ? "true" : undefined}
            onClick={handleSubmit(() => onSubmit(getValues()),(err)=> console.log(err))}
            disabled={isActiveSubmit}
            permission={"CR021"}
          >
            SAVE
          </Button>
        </div>
      }
    </div>
  )
}